import React, { Component } from 'react';
import ImageGallery from 'react-image-gallery';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css'; 


class GalleryImagev1 extends React.Component {
    
    constructor(props){
        super(props);

        this.state = {
          photoIndex: 0,
          isOpen: false,
          isEnd:true,
          galleryActiveIndex: 0,
          windowWidth: window.innerWidth
        };

        this._renderCustomControls = this._renderCustomControls.bind(this);
    }

    _renderCustomControls(){
      this.setState({ isOpen: !this.state.isOpen })
    }
    
    render() {
      const { photoIndex, isOpen, windowWidth } = this.state;
      const { galleryImages } = this.props;
      return (
        <div>
          <ImageGallery 
              ref={i => this._imageGallery = i}
              items={galleryImages} 
              infinite={false} 
              showPlayButton={false} 
              useTranslate3D={false} 
              showFullscreenButton={false}
              slideDuration={1000}
              slideInterval={5000}
              renderCustomControls={ (event,index) => {
                if(photoIndex < (galleryImages.length)) {
                  return <div className='image-gallery-custom-action' onClick={this._renderCustomControls.bind(this)}></div>
                }
              }}
              onSlide={ (currentIndex) => {
                if(!isOpen){
                  this.setState({
                    photoIndex: currentIndex,
                  })
                }
              }}
              />
            {isOpen && (
              <Lightbox
                wrapperClassName={(photoIndex===0) ? ''  : (photoIndex === galleryImages.length-1 ? 'moved-end' : 'moved' )}
                mainSrc={galleryImages[photoIndex]['hd']}
                nextSrc={galleryImages[(photoIndex + 1) % galleryImages.length]['hd']}
                prevSrc={galleryImages[(photoIndex + galleryImages.length - 1) % galleryImages.length]['hd']}
                onCloseRequest={() => this.setState({ isOpen: false })}
                onMovePrevRequest={() => {
                  let prevIndex = ((photoIndex-1) + galleryImages.length) % galleryImages.length;
                  if(prevIndex < galleryImages.length - 1) {
                    this.setState({
                      photoIndex: prevIndex
                    })
                    this._imageGallery.setState({currentIndex: prevIndex })
                  }
                }}
                onMoveNextRequest={() => {
                  let nextIndex = (photoIndex === (galleryImages.length -1)) ? 0 : (photoIndex + 1) % galleryImages.length;
                  if(nextIndex>0){
                    this.setState({
                      photoIndex: nextIndex
                    })
                    this._imageGallery.setState({currentIndex: nextIndex })
                  }
                }}
              />
            )}
        </div>
      );
    }
  
  }

  export default GalleryImagev1;


// WEBPACK FOOTER //
// ./src/components/GalleryImagev1.js